<route lang="yaml">
meta:
  title: 主页
  icon: ant-design:home-twotone
</route>

<script setup lang="ts">
import { computed } from 'vue'
import { useUserStore } from '@/store/modules/user'

const userStore = useUserStore()
const userName = computed(() => userStore.username || userStore.account || '访客')
const currentDate = computed(() => {
  return new Date().toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
  })
})
</script>

<template>
  <div class="dashboard-container">
    <div class="welcome-section">
      <div class="welcome-header">
        <div class="welcome-text">
          <h1 class="welcome-title">
            欢迎回来，{{ userName }}
          </h1>
          <p class="welcome-subtitle">
            今天是 {{ currentDate }}，请进入左侧菜单进行管理操作。
          </p>
        </div>
        <div class="welcome-actions">
          <ElButton size="small" plain type="danger" @click="userStore.logout()">
            <FaIcon name="i-ep:switch-button" class="mr-1" />
            退出
          </ElButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.dashboard-container {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f5f5;
}

.welcome-section {
  margin-bottom: 24px;
}

.welcome-header {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
}

.welcome-text {
  min-width: 0;
}

.welcome-actions {
  flex: 0 0 auto;
}

.welcome-title {
  margin: 0 0 8px;
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

.welcome-subtitle {
  margin: 0;
  font-size: 14px;
  color: #666;
}

@media (width <= 768px) {
  .dashboard-container {
    padding: 16px;
  }

  .welcome-title {
    font-size: 24px;
  }
}
</style>
